import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
export const Trash = (param)=>{
    let { size = 24, testId, style, className } = param;
    return /*#__PURE__*/ _jsx("svg", {
        width: size,
        height: size,
        "data-testid": testId,
        style: style,
        className: className,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ _jsx("path", {
            d: "M9.40039 2.26001H14.6904M12.0004 9.60001V18.64M15.3104 9.60001V18.64M8.69039 9.60001V18.64M5.39039 6.25001V20.45C5.39039 21.16 5.98039 21.74 6.71039 21.74H17.2904C18.0204 21.74 18.6104 21.16 18.6104 20.45V6.25001M4.06039 6.25001H19.9404C20.3104 6.25001 20.6004 5.96001 20.6004 5.60001V4.31001C20.6004 3.95001 20.3004 3.66001 19.9404 3.66001H4.06039C3.69039 3.66001 3.40039 3.95001 3.40039 4.31001V5.60001C3.40039 5.96001 3.70039 6.25001 4.06039 6.25001Z",
            stroke: "currentColor",
            strokeWidth: 1.5 * (24 / size),
            strokeLinecap: "round"
        })
    });
};
